export enum EmploymentOptionEnum {
  UNEMPLOYED = "UNEMPLOYED",
  EMPLOYED = "EMPLOYED",
  SELFEMPLOYED = "SELFEMPLOYED",
  RETIRED = "RETIRED",
  STUDENT = "STUDENT",
  ATHOMETRADER = "ATHOMETRADER",
  HOMEMAKER = "HOMEMAKER"
}
